/**
 * Começo e fim de conversa no assistente.
 *
 * Sem histórico: a conversa vive só na tela, e conversa velha não se acessa
 * (decisão de 29/10/2026). Mas contexto velho atrapalha — "refatura a
 * entrada" depois de falar do Vitor e do Francisco não diz de qual —, então
 * uma conversa ACABA por três motivos: o botão "Nova conversa", a IA dizer
 * que o pedido é assunto novo, ou 20 minutos parada. Acabou, some da tela e
 * do que vai para a IA.
 */

export const MINUTOS_PARADA = 20;

/**
 * Começa uma conversa nova. `manter` é quantas mensagens do fim continuam —
 * no assunto novo, a pergunta que o abriu.
 */
export const encerrar = (conversa = [], manter = 0) =>
  (manter > 0 ? conversa.slice(-manter) : []);

/** A conversa ficou parada tempo demais? */
export const parada = (conversa = [], agora = Date.now(), minutos = MINUTOS_PARADA) => {
  const ultima = conversa[conversa.length - 1];
  return Boolean(ultima?.em) && agora - ultima.em > minutos * 60 * 1000;
};

/*
 * A conversa sobrevive a recarregar a página: trocar de aba ou dar F5 não é
 * pedir conversa nova (29/10/2026). Fica no sessionStorage, por laboratório —
 * some quando a aba do navegador fecha, e nunca vai para o servidor. O que
 * falhar aqui (aba anônima, armazenamento cheio) só significa começar vazio.
 */
const CHAVE = 'assistente:conversa';

export const lerConversaGuardada = (laboratoryId) => {
  try {
    const salvo = JSON.parse(window.sessionStorage.getItem(CHAVE) || 'null');
    return salvo?.laboratoryId === laboratoryId
      ? { conversa: salvo.conversa || [], foco: salvo.foco || null }
      : { conversa: [], foco: null };
  } catch {
    return { conversa: [], foco: null };
  }
};

export const guardarConversa = (laboratoryId, conversa, foco) => {
  try {
    if (!laboratoryId) return;
    window.sessionStorage.setItem(CHAVE, JSON.stringify({ laboratoryId, conversa: conversa.slice(-60), foco }));
  } catch { /* começa vazia da próxima vez */ }
};
